// Polyfill for Object.groupBy (Safari < 18, older browsers)
if (!Object.groupBy) {
  Object.groupBy = function (array, callback) {
    if (!Array.isArray(array)) {
      throw new TypeError('Object.groupBy: first argument must be an array');
    }
    if (typeof callback !== 'function') {
      throw new TypeError('Object.groupBy: second argument must be a function');
    }
    return array.reduce((groups, item) => {
      const key = callback(item);
      (groups[key] ||= []).push(item);
      return groups;
    }, {});
  };
}